export default __webpack_public_path__ + "be80084f0b4407248e9ec708a65569e5.png";